import { render } from "./AgentsArea.vue?vue&type=template&id=08412cf2"
import script from "./AgentsArea.vue?vue&type=script&lang=js"
export * from "./AgentsArea.vue?vue&type=script&lang=js"

import "./AgentsArea.vue?vue&type=style&index=0&id=08412cf2&lang=scss"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__